import React from "react";

export default function LoginBackgroundIcon(props) {
  return (
    <svg width={985} height={473} viewBox="0 0 985 473" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={985} height={473} fill="#EEEEEE" />
      <g clipPath="url(#clip0)">
        <rect width={1520} height={700} transform="translate(-414 -135)" fill="white" />
        <path d="M1106 -136H-121V564H1106V-136Z" fill="#CA367E" />
        <path d="M1106 -136H-121V564H1106V-136Z" fill="#CA367E" />
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x={-121} y={-135} width={1227} height={700}>
          <path d="M1106 -135H-121V565H1106V-135Z" fill="#CA367E" fillOpacity="0.5" />
        </mask>
        <g mask="url(#mask0)">
          <path
            d="M928.019 14.0968C959.323 14.0968 984.708 39.4869 984.708 70.798C984.708 101.737 959.892 126.97 928.96 127.48H928.019H56.9811C27.8328 127.558 4.27109 151.242 4.3495 180.397C4.42791 209.1 27.4211 232.49 56.099 233.02H56.9615H927.999C959.304 233.02 984.689 258.41 984.689 289.721C984.689 320.659 959.872 345.893 928.94 346.402H927.999H56.9811C27.8328 346.422 4.23188 370.067 4.25148 399.222C4.27108 428.003 27.3427 451.453 56.1186 451.962H56.9811H984.689V455.884H56.9811C25.6765 455.884 0.29187 430.493 0.29187 399.182C0.29187 368.244 25.1081 343.011 56.0402 342.501H56.9811H928.019C957.167 342.481 980.768 318.836 980.749 289.682C980.729 260.9 957.657 237.451 928.881 236.941H927.999H56.9811C25.6765 236.882 0.350671 211.453 0.409477 180.122C0.468283 149.262 25.2061 124.107 56.0402 123.539H56.9811H928.019C957.167 123.519 980.768 99.874 980.749 70.7196C980.729 41.9376 957.657 18.4886 928.881 17.9789H927.999H375V14.0576H928.019V14.0968Z"
            fill="#EDEDED"
          />
          <path
            d="M465.586 16.0572C465.586 20.9391 461.646 24.88 456.766 24.88C451.885 24.88 447.945 20.9391 447.945 16.0572C447.945 11.1752 451.885 7.23438 456.766 7.23438C461.646 7.23438 465.586 11.1752 465.586 16.0572Z"
            fill="#FFFEFD"
          />
          <path
            d="M631.792 16.0572C631.792 20.9391 627.852 24.88 622.972 24.88C618.091 24.88 614.151 20.9391 614.151 16.0572C614.151 11.1752 618.091 7.23438 622.972 7.23438C627.852 7.23438 631.792 11.1752 631.792 16.0572Z"
            fill="white"
          />
          <path
            d="M925 16.0572C925 20.9391 921.06 24.88 916.179 24.88C911.298 24.88 907.358 20.9391 907.358 16.0572C907.358 11.1752 911.298 7.23438 916.179 7.23438C921.06 7.23438 925 11.1752 925 16.0572Z"
            fill="#EDEDED"
          />
          <path
            d="M133.174 125.539C133.174 130.421 129.234 134.361 124.353 134.361C119.472 134.361 115.532 130.421 115.532 125.539C115.532 120.657 119.472 116.716 124.353 116.716C129.234 116.716 133.174 120.657 133.174 125.539Z"
            fill="#EDEDED"
          />
          <path
            d="M465.586 125.539C465.586 130.421 461.646 134.361 456.766 134.361C451.885 134.361 447.945 130.421 447.945 125.539C447.945 120.657 451.885 116.716 456.766 116.716C461.646 116.716 465.586 120.657 465.586 125.539Z"
            fill="#EDEDED"
          />
          <path
            d="M631.792 125.539C631.792 130.421 627.852 134.361 622.972 134.361C618.091 134.361 614.151 130.421 614.151 125.539C614.151 120.657 618.091 116.716 622.972 116.716C627.852 116.716 631.792 120.657 631.792 125.539Z"
            fill="#EDEDED"
          />
          <path
            d="M797.998 125.539C797.998 130.421 794.058 134.361 789.177 134.361C784.296 134.361 780.356 130.421 780.356 125.539C780.356 120.657 784.296 116.716 789.177 116.716C794.058 116.716 797.998 120.657 797.998 125.539Z"
            fill="#FFFEFD"
          />
          <path
            d="M925 125.539C925 130.421 921.06 134.361 916.179 134.361C911.298 134.361 907.358 130.421 907.358 125.539C907.358 120.657 911.298 116.716 916.179 116.716C921.06 116.716 925 120.657 925 125.539Z"
            fill="#EDEDED"
          />
          <path
            d="M797.998 235.001C797.998 239.882 794.058 243.823 789.177 243.823C784.296 243.823 780.356 239.882 780.356 235.001C780.356 230.119 784.296 226.178 789.177 226.178C794.058 226.178 797.998 230.138 797.998 235.001Z"
            fill="#EDEDED"
          />
          <path
            d="M925 235.001C925 239.882 921.06 243.823 916.179 243.823C911.298 243.823 907.358 239.882 907.358 235.001C907.358 230.119 911.298 226.178 916.179 226.178C921.06 226.178 925 230.138 925 235.001Z"
            fill="#EDEDED"
          />
          <path
            d="M299.38 344.481C299.38 349.363 295.44 353.304 290.559 353.304C285.679 353.304 281.739 349.363 281.739 344.481C281.739 339.599 285.679 335.658 290.559 335.658C295.44 335.658 299.38 339.619 299.38 344.481Z"
            fill="#EDEDED"
          />
          <path
            d="M465.586 344.481C465.586 349.363 461.646 353.304 456.766 353.304C451.885 353.304 447.945 349.363 447.945 344.481C447.945 339.599 451.885 335.658 456.766 335.658C461.646 335.658 465.586 339.619 465.586 344.481Z"
            fill="white"
          />
          <path
            d="M631.792 344.481C631.792 349.363 627.852 353.304 622.972 353.304C618.091 353.304 614.151 349.363 614.151 344.481C614.151 339.599 618.091 335.658 622.972 335.658C627.852 335.658 631.792 339.619 631.792 344.481Z"
            fill="#292A5C"
          />
          <path
            d="M797.998 344.481C797.998 349.363 794.058 353.304 789.177 353.304C784.296 353.304 780.356 349.363 780.356 344.481C780.356 339.599 784.296 335.658 789.177 335.658C794.058 335.658 797.998 339.619 797.998 344.481Z"
            fill="#EDEDED"
          />
          <path
            d="M614 234.783C614 228.823 618.822 224 624.781 224C630.74 224 635.562 228.823 635.562 234.783C635.562 240.744 630.74 245.567 624.781 245.567C618.822 245.567 614 240.744 614 234.783Z"
            fill="white"
          />
          <path
            d="M281 234.783C281 228.823 285.822 224 291.781 224C297.74 224 302.562 228.823 302.562 234.783C302.562 240.744 297.74 245.567 291.781 245.567C285.822 245.567 281 240.744 281 234.783Z"
            fill="white"
          />
          <path
            d="M124.353 462.785C119.472 462.785 115.532 458.844 115.532 453.962C115.532 449.08 119.472 445.14 124.353 445.14C129.234 445.14 133.174 449.08 133.174 453.962C133.174 458.825 129.234 462.785 124.353 462.785Z"
            fill="#EDEDED"
          />
          <path
            d="M299.38 453.962C299.38 458.844 295.44 462.785 290.559 462.785C285.679 462.785 281.739 458.844 281.739 453.962C281.739 449.08 285.679 445.14 290.559 445.14C295.44 445.14 299.38 449.08 299.38 453.962Z"
            fill="#EDEDED"
          />
          <path
            d="M442.711 453.962C442.711 446.202 448.992 439.904 456.765 439.904C464.522 439.904 470.819 446.186 470.819 453.962C470.819 461.721 464.539 468.018 456.767 468.019C449.006 468.001 442.711 461.715 442.711 453.962Z"
            fill="#CA367E"
            stroke="#FFFEFD"
            strokeWidth={4}
          />
          <path
            d="M775.623 16.0575C775.623 8.57569 781.698 2.5 789.177 2.5C796.656 2.5 802.731 8.57569 802.731 16.0575C802.731 23.5393 796.656 29.615 789.177 29.615C781.681 29.615 775.623 23.5413 775.623 16.0575Z"
            fill="#CA367E"
            stroke="#EDEDED"
            strokeWidth={5}
          />
          <path
            d="M443.5 235.057C443.5 227.576 449.575 221.5 457.054 221.5C464.533 221.5 470.608 227.576 470.608 235.057C470.608 242.539 464.533 248.615 457.054 248.615C449.558 248.615 443.5 242.541 443.5 235.057Z"
            fill="#CA367E"
            stroke="#EDEDED"
            strokeWidth={5}
          />
          <path
            d="M801.051 453.962L789.177 465.838L777.304 453.962L789.177 442.087L801.051 453.962Z"
            fill="#CA367E"
            stroke="#FFFEFD"
            strokeWidth={4}
          />
          <path
            d="M290.559 137.964L278.137 125.539L290.559 113.114L302.982 125.539L290.559 137.964Z"
            fill="#CA367E"
            stroke="#EDEDED"
            strokeWidth={4}
          />
          <path d="M635.438 344.481L622.971 356.951L610.504 344.481L622.971 332.012L635.438 344.481Z" fill="#EDEDED" />
          <path
            d="M124.353 248.409L109.92 223.394H138.787L124.353 248.409Z"
            fill="#CA367E"
            stroke="#EDEDED"
            strokeWidth={4}
          />
          <path
            d="M457.06 32.1582L441.919 17.0179C438.027 13.1255 438.027 6.81174 441.919 2.91932C445.812 -0.973106 452.126 -0.973106 456.019 2.91932L471.159 18.0596C475.008 21.9958 474.937 28.3095 471 32.1582C467.124 35.9473 460.933 35.9473 457.06 32.1582Z"
            fill="#EDEDED"
          />
          <path d="M461.349 10.0957L463.231 11.9771L450.978 24.2303L449.096 22.3489L461.349 10.0957Z" fill="#CA367E" />
          <path
            d="M776.486 129.834L787.192 111.291C789.944 106.524 796.043 104.889 800.81 107.642C805.578 110.394 807.212 116.493 804.459 121.261L793.754 139.804C790.948 144.541 784.831 146.106 780.094 143.3C775.431 140.536 773.829 134.556 776.486 129.834Z"
            fill="#EDEDED"
          />
          <path d="M798.907 128.267L797.576 130.572L782.569 121.907L783.9 119.603L798.907 128.267Z" fill="#CA367E" />
          <path
            d="M907.06 358.158L891.919 343.018C888.027 339.125 888.027 332.812 891.919 328.919C895.812 325.027 902.126 325.027 906.019 328.919L921.159 344.06C925.008 347.996 924.937 354.31 921 358.158C917.124 361.947 910.933 361.947 907.06 358.158Z"
            fill="#EDEDED"
          />
          <path d="M911.349 336.096L913.231 337.977L900.978 350.23L899.096 348.349L911.349 336.096Z" fill="#CA367E" />
          <path
            d="M623.06 470.158L607.919 455.018C604.027 451.125 604.027 444.812 607.919 440.919C611.812 437.027 618.126 437.027 622.019 440.919L637.159 456.06C641.008 459.996 640.937 466.31 637 470.158C633.124 473.947 626.933 473.947 623.06 470.158Z"
            fill="#EDEDED"
          />
          <path d="M627.349 448.096L629.231 449.977L616.978 462.23L615.096 460.349L627.349 448.096Z" fill="#EDEDED" />
          <path d="M628.253 449L630.135 450.881L617.881 463.135L616 461.253L628.253 449Z" fill="#CA367E" />
          <path
            d="M293.22 255.346L273.754 235.88C268.749 230.876 268.749 222.758 273.754 217.753C278.758 212.749 286.876 212.749 291.881 217.753L311.348 237.219C316.296 242.28 316.204 250.398 311.143 255.346C306.159 260.218 298.2 260.218 293.22 255.346Z"
            fill="#EDEDED"
          />
          <path d="M298.735 226.98L301.154 229.399L285.4 245.154L282.981 242.735L298.735 226.98Z" fill="#CA367E" />
          <path
            d="M110.419 348.768L121.125 330.225C123.877 325.457 129.976 323.823 134.743 326.576C139.51 329.328 141.145 335.427 138.392 340.194L127.687 358.738C124.881 363.474 118.764 365.039 114.027 362.233C109.364 359.469 107.762 353.489 110.419 348.768Z"
            fill="#EDEDED"
          />
          <path d="M132.84 347.201L131.509 349.505L116.502 340.841L117.833 338.537L132.84 347.201Z" fill="#CA367E" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={1520} height={700} fill="white" transform="translate(-414 -135)" />
        </clipPath>
      </defs>
    </svg>
  );
}
